/* eslint-disable no-undef */
import React from "react";
import { Link, Route, Switch } from "react-router-dom";
import Masonry from "masonry-layout";

import { fadeIn, setMeta } from "../helpers";

import Loading from "./Loading";
import WorkFilters from "./WorkFilters";
import WorkThumbnail from "./WorkThumbnail";

class WorkCollection extends React.Component {
  constructor(props) {
    super(props);
    this.animatePegasus = this.animatePegasus.bind(this);
    this.checkGutterSize = this.checkGutterSize.bind(this);
    this.checkNumberOfColumns = this.checkNumberOfColumns.bind(this);
    this.reorderWork = this.reorderWork.bind(this);
    this.masonry = this.masonry.bind(this);
    this.updateShownWork = this.updateShownWork.bind(this);

    this.pegasusContainerRef = React.createRef();
    this.pegasusRef = React.createRef();

    // initial state with default values
    this.state = {
      columns: 3,
      gutterSize: 30,
      applyMasonry: false,
      shownWork: [],
    };
  }

  // Animate the looping pegasus gif just above the footer.
  // The animation speed is based on the width of the screen,
  // so the pegasus doesn't seem too fast or slow regarsless of
  // the viewer's screen width.
  animatePegasus() {
    let windowWidth = window.innerWidth;
    let durationModifier = 1.5;

    switch (true) {
      case windowWidth < 500:
        break;
      case windowWidth < 650:
        durationModifier = 1.8;
        break;
      case windowWidth < 1000:
        durationModifier = 2.33;
        break;
      case windowWidth < 1400:
        durationModifier = 2.8;
        break;
      default:
        durationModifier = 3.5;
        break;
    }

    gsap.to("#pegasus", {
      duration: 3.33 * durationModifier,
      ease: "power1.in",
      motionPath: {
        align: "#pegasus--path__path",
        alignOrigin: [0.5, 1],
        autoRotate: true,
        path: "#pegasus--path__path",
      },
      scrollTrigger: ".pegasus--container",
    });
  }

  // Looks at the CSS for thumbnails where we've hidden the column count
  // (as this is controlled by CSS). Is used to create a checkerboard
  // effect based for logo pages.
  checkNumberOfColumns() {
    if (document.querySelector(".pageContent--workThumbnails")) {
      let prevNumOfColumns = this.state.columns;
      let numOfColumns = window
        .getComputedStyle(document.querySelector(".pageContent--workThumbnails"), ":after")
        .getPropertyValue("content");

      numOfColumns = parseInt(numOfColumns.charAt(1), 10);

      if (prevNumOfColumns !== numOfColumns) {
        this.setState({ columns: numOfColumns });
      }
    }
  }

  // This checks the work collection sortby state and then
  // resorts the work on the page by that order.
  reorderWork() {
    let shownWork = this.state.shownWork;
    let sortBy = this.props.work.sortBy;

    // Sometimes shown work is not there, as in when you go from a project page
    // to a work collection page so the component is re-initialized with an
    // empty  shownWork state element
    if (shownWork.length === 0) {
      this.updateShownWork();

      var waitForShownWork = setInterval(() => {
        if (this.state.shownWork.length > 0) {
          this.reorderWork();
          clearInterval(waitForShownWork);
        }
      }, 100);
    }

    if (sortBy === "az") {
      shownWork.sort((a, b) => {
        if (a.title < b.title) return -1;
        if (a.title > b.title) return 1;
        return 0;
      });
    } else if (sortBy === "new") {
      // sort by date, then title if dates are equal
      shownWork.sort((a, b) => {
        if (a.date > b.date) return -1;
        if (a.date < b.date) return 1;

        // Equal date fallback, sort by title
        if (a.title < b.title) return -1;
        if (a.title > b.title) return 1;

        // else, equal
        return 0;
      });
    } else {
      // sort by custom 'default' order
      shownWork.sort((a, b) => {
        if (a.order < b.order) return -1;
        if (a.order > b.order) return 1;
        return 0;
      });
    }

    this.setState({ shownWork: shownWork });
    this.masonry();
  } // end reorderWork()

  masonry() {
    if (this.state.applyMasonry !== true) {
      return;
    }

    if (this.workMasonry) {
      this.workMasonry.destroy();
    }

    let workThumbnails = document.querySelector(".pageContent--workThumbnails");
    if (workThumbnails) {
      this.workMasonry = new Masonry(workThumbnails, {
        itemSelector: ".workThumbnail",
        columnWidth: ".workThumbnail",
        percentPosition: true,
        gutter: this.state.gutterSize,
      });
    }
  }

  updateMeta() {
    if (this.props.work.activeCollection === null) {
      setMeta("description");
      setMeta("title");
      setMeta("image");
      return;
    }

    if (this.props.pageType === "workCollection") {
      if (this.props.work.activeType === "home") {
        setMeta("description");
        setMeta("title");
        setMeta("image");
      } else {
        setMeta("title", this.props.work.collectionTitle + " - Chermayeff & Geismar & Haviv");
      }
    }
  }

  componentDidMount() {
    fadeIn();
    this.checkNumberOfColumns();
    this.checkGutterSize();
    this.updateShownWork();

    this.resizeChecks = () => {
      this.checkNumberOfColumns();
      this.checkGutterSize();
    };

    this.updateMeta();

    window.addEventListener("resize", this.resizeChecks, false);

    if (
      this.props.work.activeType === "graphics" ||
      this.props.work.activeCollection === "history"
    ) {
      this.setState({ applyMasonry: true });
    }

    if (this.props.pageType === "" && this.props.hasOwnProperty("params")) {
      if (this.props.params.hasOwnProperty("workType")) {
        this.props.setMaster("pageType", "workCollection");
      }
    }
  }

  checkGutterSize() {
    if (window.innerWidth < 640) {
      var gutterSize = 15;
    } else {
      gutterSize = 30;
    }

    if (this.state.gutterSize !== gutterSize) {
      this.setState({ gutterSize });
      this.masonry();
    }
  }

  updateShownWork() {
    if (this.state.shownWork.length > 0) {
      this.setState({ shownWork: [] });
    }

    var waitForWork = setInterval(() => {
      if (
        this.props.work.theWork[this.props.work.activeCollection][this.props.work.activeType]
          .length > 0
      ) {
        this.setState({
          shownWork:
            this.props.work.theWork[this.props.work.activeCollection][this.props.work.activeType],
        });
        this.masonry();
        clearInterval(waitForWork);
      }
    }, 250);
  }

  componentWillUpdate(nextProps, nextState) {
    // If we change to a page that has a workType param we know it's a work collection page.
    // Make sure it's set, if it isn't already.
    if (this.props.hasOwnProperty("params")) {
      if (
        this.props.params.hasOwnProperty("workType") &&
        this.props.pageType !== "workCollection"
      ) {
        this.props.setMaster("pageType", "workCollection");
      }
    }

    // column changes
    if (this.state.columns !== nextState.columns) {
      if (this.state.applyMasonry) {
        this.masonry();
      }
    }
  }

  componentDidUpdate(prevProps, prevState) {
    fadeIn();

    // Active work type changes
    if (
      prevProps.work.activeCollection !== this.props.work.activeCollection ||
      prevProps.work.activeType !== this.props.work.activeType
    ) {
      this.updateMeta();

      if (prevProps.work.activeType !== null && prevProps.work.activeCollection !== null) {
        this.updateShownWork();
      }
    }

    //  workType parameter check
    if (this.props.hasOwnProperty("params") && prevProps.hasOwnProperty("params")) {
      if (prevProps.params.workType !== this.props.params.workType) {
        this.props.setMaster("workType", this.props.params.workType);
      }
    }

    // sortBy change
    if (prevProps.work.sortBy !== "" && prevProps.work.sortBy !== this.props.work.sortBy) {
      this.reorderWork();
    }

    // When work is first added
    if (this.state.shownWork.length > 0 && prevState.shownWork.length === 0) {
      this.resizeChecks();
    }

    // workType change
    if (this.props.work.activeType && this.props.work.activeType !== prevProps.work.activeType) {
      if (
        this.props.work.activeType === "graphics" ||
        this.props.work.activeCollection === "history"
      ) {
        this.setState({ applyMasonry: true });
      } else if (this.state.applyMasonry) {
        this.setState({ applyMasonry: false });
      }
    }

    this.masonry();
  }

  componentWillUnmount() {
    window.removeEventListener("resize", this.resizeChecks, false);
  }

  render() {
    let thumbnailClasses = ["pageContent--workThumbnails", "js-fade__quick", "js-fadeMeIn"];
    const showFilters =
      this.props.pageType === "workCollection" && this.props.work.activeType !== "home"
        ? true
        : false;

    if (this.state.applyMasonry) {
      thumbnailClasses.push("masonry");
    }

    let mainElement = document.querySelector("main");

    if (mainElement) {
      if (this.props.work.activeCollection === "history") {
        document.querySelector("main").classList.add("pageType-workCollection__history");
      } else {
        document.querySelector("main").classList.remove("pageType-workCollection__history");
      }
    }

    // Waiting for work
    if (this.state.shownWork.length === 0) {
      const main = document.querySelector("main");

      if (main) {
        main.classList.add("main--loading");
      }

      return (
        <div className="workCollection">
          <div className="content--container workCollection--container">
            <div className="preContent">
              <div className="waitingForThumbnails">
                {this.props.pageType === "project" && (
                  <h1 className="moreWork">{this.props.work.collectionTitle}</h1>
                )}
                {showFilters && (
                  <WorkFilters
                    activeCollection={this.props.work.activeCollection}
                    activeType={this.props.work.activeType}
                    columns={this.state.columns}
                    enabled={false}
                    params={this.props.params}
                    pathname={this.props.pathname}
                    reorderWork={this.reorderWork}
                    masonry={this.masonry}
                    setMaster={this.props.setMaster}
                    sortBy={this.props.work.sortBy}
                  />
                )}
              </div>
            </div>
            <Loading />
          </div>
        </div>
      );
    } else {
      document.querySelector("main").classList.remove("main--loading");
      setTimeout(() => {
        this.animatePegasus();
      }, 200);

      return (
        <div className="workCollection">
          <div className="content--container workCollection--container">
            <div className="preContent">
              <Switch>
                <Route
                  path="/work/project/:slug"
                  render={props => <h1 className="moreWork">{this.props.work.collectionTitle}</h1>}
                />
                <Route
                  path="/(work|history)/:type?/:sort?"
                  render={props => (
                    <WorkFilters
                      activeCollection={this.props.work.activeCollection}
                      activeType={this.props.work.activeType}
                      columns={this.state.columns}
                      enabled={true}
                      params={this.props.params}
                      pathname={this.props.pathname}
                      reorderWork={this.reorderWork}
                      masonry={this.masonry}
                      setMaster={this.props.setMaster}
                      sortBy={this.props.work.sortBy}
                    />
                  )}
                />
              </Switch>
            </div>
            <div
              className={
                this.props.pageType === "workCollection" ? "js-fade__slow js-fadeMeIn" : ""
              }>
              <Route
                path="/"
                exact
                render={() => (
                  <div className="preamble--container">
                    <h1 className="preamble js-fade__slow js-fadeMeIn">
                      Creators of many of the world’s most iconic and enduring brands, Chermayeff &
                      Geismar & Haviv is an independent design firm specializing in the development
                      of trademarks and identity programs.
                    </h1>
                    <div id="peacock" />
                  </div>
                )}
              />
              <section className={thumbnailClasses.join(" ")}>
                {Object.keys(this.state.shownWork).map(i => (
                  <WorkThumbnail
                    checkerThumbs={this.props.work.checkerThumbs}
                    columns={this.state.columns}
                    currentOrder={parseInt(i, 10) + 1}
                    details={this.state.shownWork[i]}
                    key={`${this.state.shownWork[i].title}-${Math.random()}`}
                    orderOfFour={(parseInt(i, 10) + 1) % 4}
                    masonry={this.masonry}
                    sortBy={this.props.work.sortBy}
                  />
                ))}
              </section>
              <Route
                path="/"
                exact
                render={() => (
                  <div className="viewMoreAndPegasus">
                    <section className="pageContent pageContent--viewAllWork">
                      <Link to="/work/logos/">View more logos</Link>
                    </section>
                    <div className="pegasus--container" ref={this.pegasusContainerRef}>
                      <svg
                        id="pegasus--path"
                        version="1.1"
                        xmlns="http://www.w3.org/2000/svg"
                        xmlnsXlink="http://www.w3.org/1999/xlink"
                        x="0px"
                        y="0px"
                        viewBox="0 0 1000 250"
                        xmlSpace="preserve">
                        <path
                          d="M-0.08,249.96c0,0,260.94,0,527.56,0c308.11,0,472.44-250,472.44-250"
                          id="pegasus--path__path"
                        />
                      </svg>
                      <img
                        alt="flying pegasus"
                        id="pegasus"
                        ref={this.pegasusRef}
                        src="/img/pegasus-v2.gif"
                      />
                    </div>
                  </div>
                )}
              />
            </div>
          </div>
        </div>
      );
    }
  } // end render()
} // end class WorkCollection extends React.Component

export default WorkCollection;



/** WEBPACK FOOTER **
 ** ./src/components/WorkCollection.js
 **/